import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../data.service';
@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnInit {

  @Input() filterGroups = [];
  @Input() filterCount = {};
  @Input() show: boolean;
  @Output() filter: EventEmitter<any> = new EventEmitter();

  constructor(public dataService: DataService) { }

  ngOnInit() {
   
  }

  updateFilter(filter) {
    this.filter.emit(filter);
  }


}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/filter-bar/filter-bar.component.ts